import React from 'react'
import ModalBody from './modal/modal-body'
import Certificate from '@/assets/images/gmd-cer.png'

type Props = {}

const Achievement = (props: Props) => {
  return (
    <ModalBody>
      <div className="flex flex-col items-center gap-6 p-4">
        <h2 className="text-2xl font-bold text-blue-500">Achievement Certificate</h2>
        <div className="relative w-full max-w-2xl overflow-hidden rounded-lg shadow-lg">
          <img 
            src={Certificate} 
            alt='certificate image' 
            className='w-full h-auto object-cover hover:scale-150 transition-transform duration-300'
          />
        </div>
        <div className="text-center space-y-2">
          <p className="text-gray-300">
            This certificate represents a significant achievement in my professional journey about microbit control competitive.
          </p>
        </div>
      </div>
    </ModalBody>
  )
}

export default Achievement